<template>
  <!-- 侧边导航 -->
  <div id="side-nav" class="side-nav">
    <div
      v-gtag:viewRules
      data-type="button"
      class="rules"
      @click="visible = true"
    >
      <!-- <span>{{ $locale.sideNav.rules }}</span> -->
    </div>
    <a
      v-gtag:download="'download-PC floating'"
      :href="downloadLink.pc"
      target="_blank"
      data-type="button"
      class="download download__nav"
    >
      <!-- <span>{{ $locale.sideNav.downloadPC }}</span> -->
    </a>
    <div class="qrcode">
      <img :src="qrcodeUrl" :alt="$locale.sideNav.scanToDownload" />
      <div class="qrcode-text">
        <!-- {{ $locale.sideNav.scanToDownload }} -->
      </div>
    </div>
    <div class="backtop" @click="backTop">TOP</div>

    <DlgRule :visible="visible" @close="visible = false" />
  </div>
</template>

<script>
import DlgRule from "components/dialog/rule.vue";
import { GenerateQrcode } from "scripts/util";

export default {
  name: "SideNav",
  components: {
    DlgRule,
  },
  data() {
    return {
      visible: false,
      downloadLink: this.$download,
      qrcodeUrl: "",
    };
  },
  created() {
    GenerateQrcode(this.downloadLink.m)
      .then((url) => {
        this.qrcodeUrl = url;
      })
      .catch((err) => {
        console.error(err);
      });
  },
  mounted() {},
  computed: {},
  methods: {
    backTop() {
      $("html").animate(
        {
          scrollTop: 0,
        },
        300
      );
    },
  },
};
</script>

<style lang="less" scoped>
@color: #705c43;
/* 侧边导航 */
.side-nav {
  position: fixed;
  top: 50%;
  right: 0;
  width: 126px;
  height: 270px;
  transform: translateY(-50%);
  padding-top: 18px;
  background: url(~images/side_nav_bg_2.png) no-repeat 0 0;
  background-size: 100% auto;
  z-index: 100;
  color: @color;

  .rules,
  .download__nav {
    display: block;
    width: 108px;
    height: 39px;
    margin-left: 14px;
    background-color: #e4ccac;
    background: url(~images/side_nav_bg_2.png) no-repeat 0 0;
    background-size: 100% auto;
    border-radius: 3px;
    // border: solid 1px #725e43;
    font-size: 14px;
    line-height: 14px;
    // color: #503f2b;
    text-align: center;
    color: @color;
  }

  .rules {
    background-image: url(~images/btn_rules.png);
  }

  .download__nav {
    background-image: url(~images/side_download.png);
  }

  .rules,
  .download__nav,
  .qrcode-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    word-break: keep-all;

    span {
      transform: scale(0.95);
    }
  }

  .qrcode {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 5px;
      left: 23px;
      width: 90px;
      height: 2px;
      background-color: orange;
      animation: translate 2s linear infinite;
      pointer-events: none;
    }

    @keyframes translate {
      0% {
        transform: translate(0, 0);
      }

      50% {
        transform: translate(0, 90px);
      }

      100% {
        transform: translate(0, 0);
      }
    }

    img {
      display: block;
      width: 100px;
      height: 100px;
      margin-left: 18px;
      background-color: #aaa;
    }

    &-text {
      padding: 0 0;
      margin: 2px 0 0 4px;
      text-align: center;
      font-size: 14px;
      line-height: 12px;
      transform: scale(0.9);
    }
  }

  .backtop {
    position: absolute;
    bottom: 12px;
    left: 50%;
    margin-left: -12px;
    cursor: pointer;
    transition: 0.1s;

    &::before {
      @border-width: 6px;
      position: absolute;
      top: -2 * @border-width;
      left: 50%;
      transform: translateX(-50%);
      content: "";
      border: @border-width solid transparent;
      border-left-width: @border-width * 0.8;
      border-right-width: @border-width * 0.8;
      border-bottom-color: @color;
      transition: 0.1s;
    }

    &:hover {
      color: var(--primary-color);

      &::before {
        border-bottom-color: var(--primary-color);
      }
    }
  }
}
</style>
